import moment from "moment";

const months = [
  { 1: "Jan" },
  { 2: "Feb" },
  { 3: "Mar" },
  { 4: "Apr" },
  { 5: "May" },
  { 6: "Jun" },
  { 7: "Jul" },
  { 8: "Aug" },
  { 9: "Sep" },
  { 10: "Oct" },
  { 11: "Nov" },
  { 12: "Dec" },
];

export const getFinancialcycle = ({ month }) => {
  const currentYear = new Date().getUTCFullYear();
  const currentmonth = months.find((monthid, index) => index + 1 == month);
  const date = `1/${month == 1 ? 12 : month - 1}/${currentYear + 1}`;
  const res = `${1}${" "}${currentmonth[month]}${" "}${currentYear}${" - "}${moment(date, "DD/MM/YYYY").endOf("month").format("DD")}${" "}${moment(date, "DD/MM/YYYY").format("MMM")}${" "}${currentYear + 1}`;
  return res;
};

export const getOther = () => {

};
